import { render, staticRenderFns } from "./deck.vue?vue&type=template&id=2db7d3af&"
import script from "./deck.vue?vue&type=script&lang=js&"
export * from "./deck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports